import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import Trans from 'view/trans';

const TransPage = () => {
	return (
		<PageTemplate>
			<Trans />
		</PageTemplate>
	);
};

export default TransPage;

 